/* unplugin-vue-components disabled */import script from "./batch-move-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./batch-move-dialog.vue?vue&type=script&lang=ts&setup=true"

import "./batch-move-dialog.vue?vue&type=style&index=0&id=c6518abe&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6518abe"]])

export default __exports__